import BigNumber from 'bignumber.js';
import { ComputedReserveData } from '../hooks/app-data-provider/useAppDataProvider';

export const getMaxLeverage = (token: ComputedReserveData): BigNumber => {
  return BigNumber(1).div(BigNumber(1).minus(BigNumber(token.baseLTVasCollateral).div(10000)));
}
